import axios from 'axios'
import http from '../config/http'

const uploadFileToS3 = async ({ file, module, recordId, tipo }) => {
  try {
    if (!recordId || !file?.name) {
      throw new Error('Missing recordId or file.name')
    }

    if (file.size > 10 * 1024 * 1024) throw new Error('The file exceeds the 10 MB limit')
    const fileExtension = file.name.includes('.') ? file.name.split('.').pop() : 'bin'
    const fileName = `${Date.now()}.${fileExtension}`

    // Step 1: Get presigned URL
    const { data } = await http.post('/api/images', {
      module,
      recordId,
      fileName,
      contentType: file.type || 'application/octet-stream',
      size: file.size,
    })

    const { url, fileUrl } = data
    console.log('Presigned URL data:', data)

    // Step 2: Upload to S3
    await axios.put(url, file, {
      headers: {
        'Content-Type': file.type,
      },
    })
    console.log('File uploaded to S3')

    // Step 3: Save metadata
    if (tipo !== 'profile' && !String(recordId).startsWith('temp-')) {
    const moduleIdKey = `${module.slice(0, -1)}Id` 
    await http.post('/api/attachments', {
      url: fileUrl,
      module,
      recordId,
      name: file.name,
      size: file.size,
      type: file.type,
      id_reference: recordId,
      [moduleIdKey]: recordId,
    })
    }

    console.log('Metadata saved to backend')
    return fileUrl

  } catch (error) {
    console.error('Error during upload:', error)
    throw error
  }
}

export default uploadFileToS3
